import React from 'react';
import Modal from 'react-responsive-modal';
import './HomeSales.scss';

import homeSales_bg from '../../../assets/img/llc/homeSales_bg.jpg';
import actionImgArray from "../../../assets/img/akce";

class HomeSales extends React.PureComponent {
  state = {
    open: false,
    activeSale: this.props.langs.sales[0]
  };

  onOpenModal = (itemId) => {
    this.setState({
      open: true,
      activeSale: this.props.langs.sales[itemId]
    });
  };

  onCloseModal = () => {
    this.setState({open: false});
  };

  renderSales = () => {
    return this.props.langs.sales.map((item) =>
      <div className="col-3 homeSales_item_col" key={item.id}>
        <button onClick={this.onOpenModal.bind(this, item.id - 1)}>
          <div className="homeSales_item">
            <div className="homeSales_item_content">
              <i className={'llc-' + item.icon}/>
              <div className="homeSales_item_title">{item.name}</div>
              <div className="homeSales_item_desc">{item.text}</div>
              <div className="homeSales_item_btn">Zobrazit více</div>
            </div>
          </div>
        </button>
      </div>
    );
  };

  renderSaleImgs = () => {
    const activeSale = this.state.activeSale;

    const urlSlashPos = actionImgArray[1].lastIndexOf("/");

    return activeSale.img.map((img, index) => {
      return <img key={index} src={img} alt={this.props.langs.imgAlt.imgAlt}/>
    })
  };

  render() {
    const {open} = this.state;
    const activeSale = this.state.activeSale;

    return (
      <section className="homeSales">
        <img src={homeSales_bg} className="homeSales_bg"/>
        <div className="container relative">
          <h2 className="text-center line">PROMO AKCE</h2>
          <h5 className="text-center">
            Nyní pro Vás máme připraveny promo akce. Udělejte radost <br/>
            sobě nebo svým blízkým dárkovým poukazem od nás.
          </h5>

          <div className="row homeSales_item_row">
            {this.renderSales()}
          </div>
        </div>

        <Modal open={open}
               onClose={this.onCloseModal}
               classNames={{
                 'modal': 'homeSales_modal',
                 'closeButton': 'homeSales_modal_close',
               }}
        >
          <h2 className="line left m-b-40">{activeSale.name}</h2>
          <div dangerouslySetInnerHTML={{__html: activeSale.desc}}/>
          {activeSale.img &&
          <div className="homeSales_modal_img">
            {this.renderSaleImgs()}
          </div>
          }
          {activeSale.pdf &&
          <div className="homeSales_modal_kupon">
            <a href={`./${activeSale.pdf}`} target="_blank"><i className="llc-pdf"/> Slevový kupón</a>
          </div>
          }
        </Modal>
      </section>
    );
  }
}

export default HomeSales;



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeSales/HomeSales.js